import React from 'react';

const Thanks = () => {
    return (
        <div>
            <h1>Thanks</h1>
        </div>
    )
}

export default Thanks;